import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const DynamicBadge = () => {
  const [badge, setBadge] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBadge = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/data-v1/v1/client/badge`, {
          cache: 'no-store',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
          },
        });
        
        if (response.ok) {
          const data = await response.json();
          setBadge(data);
        }
      } catch (error) {
        console.error('Failed to fetch dynamic badge:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBadge();
  }, []);

  if (loading || !badge || !badge.visible) return null;

  return (
    <motion.div 
      initial={{ opacity: 0, y: 16 }} 
      animate={{ opacity: 1, y: 0 }}
      className="dynamic-badge inline-flex items-center gap-2 px-4 py-1.5 border text-[10px] font-semibold tracking-[0.2em] uppercase mb-8"
    >
      {badge.icon === 'Sparkles' ? <Sparkles className="w-3.5 h-3.5" /> : <span>{badge.icon}</span>}
      {badge.text}
    </motion.div>
  );
};

export default DynamicBadge;
